import { COMPLAINTS_API_ERROR, API_ERROR } from "../actions";
import { AnyAction } from "redux";

export type ErrorState = {
  error?: any;
};

const intialState: ErrorState = {
  error: null,
};

export const errors = (
  state: ErrorState = intialState,
  { type, payload }: AnyAction
): ErrorState => {
  switch (type) {
    case API_ERROR:
    case COMPLAINTS_API_ERROR:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};
